"use client";
import React from "react";
import { Tabs, Tab } from "@heroui/react";
import { redirect, usePathname } from "next/navigation";
import Link from "next/link";

export default function ProfileTabs({
  params,
}: {
  params: {
    handle: string;
  };
}) {
  const pathname = usePathname();
  const handle = params.handle;

  const selectedKey = pathname?.split("/")[3] || "";

  if (!handle) redirect("/");

  return (
    <div className="flex flex-col">
      <Tabs
        classNames={{
          base: "p-0",
          tabList: "p-0",
        }}
        aria-label="Options"
        color="primary"
        variant="underlined"
        selectedKey={selectedKey}
      >
        <Tab
          href={`/artist/${handle}`}
          key=""
          //anchor text
          aria-label={`Overview of ${handle}`}
          as={Link}
          title={
            <div className="flex items-center space-x-2">
              {/* <MusicIcon width={17} height={17} /> */}
              <span className="text-xs">Overview</span>
            </div>
          }
        />
        {/* <Tab
          href={`/artist/${handle}/videos`}
          key="videos"
          as={Link}
          title={
            <div className="flex items-center space-x-2">
              <span className="text-xs">Videos</span>
            </div>
          }
          /> */}
        {/* <VideoIcon width={17} height={17} /> */}
        {/* <Tab
          key="schedule"
          as={Link}
          href={`/artist/${handle}/schedule`}
          title={
            <div className="flex items-center space-x-2">
            <span className="text-xs">Schedule</span>
            </div>
            }
            /> */}
        {/* <VideoIcon width={17} height={17} /> */}
        <Tab
          href={`/artist/${handle}/tracks`}
          key="tracks"
          aria-label={`All tracks by ${handle}`}
          as={Link}
          title={
            <div className="flex items-center space-x-2">
              {/* <MusicIcon width={16} height={16} /> */}
              <span className="text-xs">All tracks</span>
            </div>
          }
        />
        <Tab
          href={`/artist/${handle}/events`}
          key="events"
          aria-label={`All events by ${handle}`}
          as={Link}
          title={
            <div className="flex items-center space-x-2">
              {/* <CalendarIcon width={16} height={16} /> */}
              <span className="text-xs">Events</span>
            </div>
          }
        />
        <Tab
          href={`/artist/${handle}/about`}
          key="about"
          aria-label={`About ${handle}`}
          as={Link}
          title={
            <div className="flex items-center space-x-2">
              {/* <InfoCircleIcon width={16} height={16} /> */}
              <span className="text-xs">About</span>
            </div>
          }
        />
      </Tabs>
    </div>
  );
}
